import { Serializable } from "@/core/api/decorators/serializable_decorator"

@Serializable
export class TaskNoteModel {
  uid: string = ""
  content: string = ""
  createdAt: string = ""
  createdBy: string = ""

  constructor(
    data: {
      uid: string
      content: string
      createdAt: string
      createdBy: string
    } | null = null,
  ) {
    if (data) {
      this.uid = data.uid
      this.content = data.content
      this.createdAt = data.createdAt
      this.createdBy = data.createdBy
    }
  }
}
